/**
 * TODO: This file will be deprecated and removed in the future.
 * This HOC will be replaced with `desktop/src/app/hooks/use-config.js`.
 *
 * NOTE: This HOC is still in use in the following places and should be migrated to use the new hook with options.fetchPolicy set to 'cache-first':
 * - desktop/src/app/components/player/meta/meta.jsx
 * - desktop/src/app/components/player/youbora/youbora-data.jsx
 * - desktop/src/app/containers/login/index.js
 * - desktop/src/app/containers/maintenance-mode/index.js
 * - desktop/src/app/hoc/deep-link.js
 * - desktop/src/app/modules/direct-carrier-billing/containers/login.js
 */
import {
  compose
} from 'recompose'
import { graphql } from 'react-apollo'

import getDeviceInfo from '../lib/device-info'
import withDeviceFingerprint from './with-device-fingerprint'

import CONFIG_QUERY from '../../graphql/queries/config.gql'

const withConfig = compose(
  withDeviceFingerprint,
  graphql(CONFIG_QUERY, {
    name: 'configQuery',
    options: ({ deviceFingerprint }) => {
      const deviceInfo = {
        ...getDeviceInfo(),
        uuid: deviceFingerprint,
        platform: 'Web'
      }
      return {
        fetchPolicy: 'cache-first',
        variables: {
          input: {
            deviceInfo
          }
        },
        notifyOnNetworkStatusChange: true
      }
    },
    props: ({
      ownProps, configQuery: {
        loading, error, config, parentalRatings, ageGroups
      }
    }) => {
      return ({
        ...ownProps,
        configLoading: loading,
        configError: error,
        appConfig: (config || {}),
        parentalRatingsData: parentalRatings,
        ageGroupsData: ageGroups
      })
    }
  })
)

export default withConfig
